exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table-view avatar {\n  font-size: 2em;\n}\n.form-el-input .no-input {\n  padding-top: 7px;\n}\n", ""]);

// exports
